import { render, staticRenderFns } from "./concernedEn.vue?vue&type=template&id=56b2734b&scoped=true&"
import script from "./concernedEn.vue?vue&type=script&lang=js&"
export * from "./concernedEn.vue?vue&type=script&lang=js&"
import style0 from "./concernedEn.vue?vue&type=style&index=0&id=56b2734b&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b2734b",
  null
  
)

export default component.exports